const GRID_PATTERN = /^[A-Z0-9]+$/;
const FIRST_FOUR_ARE_DIGITS_PATTERN = /^[0-9]{4}.+/;
const LAST_TWO_ARE_DIGITS_PATTERN = /.+[0-9]{2}$/;
const CHARACTER_SET = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ';
const NUMBER_OF_CHECK_DIGITS = 2;

const checksumIsCorrect = (grid: string): boolean => {
    const dataOnly = grid.slice(0, grid.length - NUMBER_OF_CHECK_DIGITS);

    let weightedCheckValue = 0;
    for (let i = 0; i < dataOnly.length; i++) {
        const positionFromEnd = dataOnly.length - i;
        weightedCheckValue += CHARACTER_SET.indexOf(dataOnly.charAt(i)) * Math.pow(2, positionFromEnd);
    }
    const checksumResult = ((38 - (weightedCheckValue % 37)) % 37).toString().padStart(NUMBER_OF_CHECK_DIGITS, '0');
    return checksumResult === grid.slice(grid.length - NUMBER_OF_CHECK_DIGITS);
};

/**
 * Grid checksum validation
 *
 * helpful links:
 * - https://jira.nmdp.org/browse/MAT-1992
 * - https://confluence.nmdp.org/display/SMO/Checksum+Logic+-+RID+and+GRID
 * - followed code example from https://gitlab.com/bethematch/appdev/b2b-gateway/b2b-gateway/-/blob/develop/common/src/main/java/org/btm/b2b/processing/transaction/adapter/common/validator/GridValidatorImpl.java?ref_type=heads
 */
export const gridChecksumValidator = (value?: string): boolean => {
    if (!value) {
        return true;
    }
    if (!GRID_PATTERN.test(value)) {
        console.debug('can only contain 0-9 and A-Z');
        return false;
    }
    if (value.startsWith('0')) {
        console.debug('cannot start with 0');
        return false;
    }
    if (!FIRST_FOUR_ARE_DIGITS_PATTERN.test(value)) {
        console.debug('first four characters must be numeric');
        return false;
    }
    if (!LAST_TWO_ARE_DIGITS_PATTERN.test(value)) {
        console.debug('last two characters must be numeric');
        return false;
    }
    if (!checksumIsCorrect(value)) {
        console.debug('checksum is incorrect');
        return false;
    }

    return true;
};
